import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import clearAuthSession from 'utils/authSession';

export default function useGuestSessionReset() {
  const dispatch = useDispatch();

  useEffect( () => {
    clearAuthSession( dispatch, { clearPersist: false } );
  }, [dispatch] );
}
